function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "c",
  cx: 0.886,
  cy: 0.818,
  r: 0.867,
  gradientTransform: "matrix(-0.632, -0.775, 0.855, -0.696, 0.542, 0.93)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6db2a5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#89e3d6"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 0.02,
  y1: 1.057,
  x2: 0.5,
  y2: 0.094,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1276cf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#20c8c1"
}));

var _ref4 = /*#__PURE__*/React.createElement("style", null, "\n            .d{opacity:.389;fill:url(#c)}\n        ");

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M1505.418,499.008s22.2-122.5,136.488-132.127,150.08-67.292,164.683-144.424,75.794-130.883,103.388-148.4S1993.418,53.7,1993.418,53.7V501.949h-488Z",
  transform: "translate(-1233.768 42.271)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M1505.418,423.694s18.375-101.415,112.991-109.381,129.136-68.03,141.225-131.884,143.441-81.552,143.441-81.552V449.36H1505.418Z",
  transform: "translate(-1143.879 94.582)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M.246,168.035s-2.251-20.591,6.872-45.755C24.043,75.6,85.116,78.03,93.8,32.163,99.827.331,170.225,0,170.225,0V168.035Z",
  transform: "translate(171.601 168.035) rotate(180)"
});

const SvgSigninBackground768 = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666,
    height: 768,
    viewBox: "0 0 666 768",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref2, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 666,
    height: 768,
    transform: "translate(0 0)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    }
  })), _ref4), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H759.971V768.521H0Z",
    transform: "translate(0 0.113)",
    style: {
      opacity: 0.828,
      fill: "url(#b)"
    }
  }), _ref5, _ref6, _ref7)));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSigninBackground768, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/signin-background-768.6f79441a.svg";
export { ForwardRef as ReactComponent };